;(function () {
  'use strict'

  angular
    .module('contrast.settings.user.tsv')
    .controller('UserTsvCtrl', UserTsvCtrl)

  function UserTsvCtrl(
    $scope,
    $q,
    $translate,
    confirmModal,
    logger,
    userTsvService,
    preferencesService,
    tsvApiConfig,
    ErrorService,
    ProfileService,
    TSV_NOTIFICATION_PROVIDER,
    TSV_DEVICE_TYPES,
    TSV_DEVICE_ENUM,
    PREFERENCE_PROPERTIES
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        system_tsv: {},
        org_tsv: {},
        tsv: {},
        token: '',
        qr: '',
        loading: false,
        google_configured: false,
        device_types: TSV_DEVICE_TYPES
      },
      promises: [],
      tsv_enabled: false,
      types: TSV_NOTIFICATION_PROVIDER
    })

    angular.extend($scope, {
      lockFields: lockFields,
      resetDevice: resetDevice,
      changeAuthenticator: changeAuthenticator,
      changeStatus: changeStatus,
      changeDeviceFromQR: changeDeviceFromQR
    })

    function init() {
      $scope.model.loading = true
      $scope.promises = []
      $scope.promises.push(_getOverrideSystemTsv())
      $scope.promises.push(_getEnabledSystemTsv())
      $scope.promises.push(_getOrgTsv())
      $scope.promises.push(_getUserTsv())

      $scope.model.email = ProfileService.getEmail()

      $q.all($scope.promises).then(function () {
        if (!$scope.model.system_tsv.override) {
          $scope.tsv_enabled = $scope.model.system_tsv.enabled
        } else {
          $scope.tsv_enabled = $scope.model.org_tsv.enabled
          if ($scope.model.org_tsv.enabled && !$scope.model.org_tsv.required) {
            $scope.tsv_enabled = $scope.model.tsv.enabled
          }
        }

        $scope.model.loading = false
      })
    }

    function lockFields() {
      return (
        !$scope.model.system_tsv.override ||
        !$scope.model.org_tsv.enabled ||
        $scope.model.org_tsv.required
      )
    }

    function resetDevice() {
      var transl = {
        dialogTitle: $translate.instant('title_pleaseConfirmAction'),
        dialogDescription: $translate.instant(
          'detail_resetDeviceDialog_resetDeviceConfirmation_twoStepVerification'
        ),
        dialogYes: $translate.instant('action_yes'),
        dialogNo: $translate.instant('action_cancel')
      }

      return confirmModal
        .open({
          title: transl.dialogTitle,
          message: transl.dialogDescription,
          dialogOptions: {
            size: 'md-sm',
            yes: transl.dialogYes,
            no: transl.dialogNo
          }
        })
        .then(function (confirmed) {
          if (confirmed) {
            return _reset()
          }
        })
    }

    function changeAuthenticator() {
      var previousType = angular.copy($scope.model.tsv.previousType)
      var newType = angular.copy($scope.model.tsv.type)

      if (!previousType) {
        return _checkUserTsvTypeConfiguration(newType)
      }

      $scope.model.loading = true
      if (previousType != newType) {
        var transl = {
          dialogTitle: $translate.instant('title_pleaseConfirmAction'),
          dialogDescription: $translate.instant(
            'detail_changeAuthenticatorDialog_changeAuthenticatorConfirmation_twoStepVerification'
          ),
          dialogYes: $translate.instant('action_yes'),
          dialogNo: $translate.instant('action_cancel')
        }

        return confirmModal
          .open({
            title: transl.dialogTitle,
            message: transl.dialogDescription,
            dialogOptions: {
              size: 'md-sm',
              yes: transl.dialogYes,
              no: transl.dialogNo
            }
          })
          .then(function (confirmed) {
            if (confirmed) {
              return _checkUserTsvTypeConfiguration(newType)
            } else {
              $scope.model.tsv.type = previousType
              $scope.model.loading = false
            }
          })
      } else {
        $scope.model.loading = false
      }
    }

    function changeStatus() {
      var tempEnabled = angular.copy($scope.tsv_enabled)
      $scope.tsv_enabled = !$scope.tsv_enabled

      var transl = {
        dialogTitle: $translate.instant('title_pleaseConfirmAction'),
        dialogDescription: $translate.instant(
          'detail_changeStatusDialog_changeStatusConfirmation_twoStepVerification'
        ),
        dialogYes: $translate.instant('action_yes'),
        dialogNo: $translate.instant('action_cancel')
      }

      return confirmModal
        .open({
          title: transl.dialogTitle,
          message: transl.dialogDescription,
          dialogOptions: {
            size: 'md-sm',
            yes: transl.dialogYes,
            no: transl.dialogNo
          }
        })
        .then(function (confirmed) {
          if (confirmed) {
            return tsvApiConfig.updateUserTsvStatus(tempEnabled).then(
              function () {
                logger.logSuccess(
                  $translate.instant('detail_twoStepVerification_changesSaved')
                )
                $scope.tsv_enabled = tempEnabled
                if (!$scope.tsv_enabled) {
                  $scope.model.tsv.type = undefined
                  $scope.model.tsv.previousType = undefined
                  $scope.model.codes = []
                  $scope.model.qr = undefined
                  $scope.model.token = undefined
                }
              },
              function (response) {
                ErrorService.processError(response)
              }
            )
          }
        })
    }

    function changeDeviceFromQR() {
      return tsvApiConfig
        .updateUserTsvDevice($scope.model.tsv.device.toUpperCase())
        .then(
          function () {
            logger.logSuccess(
              $translate.instant('detail_twoStepVerification_deviceReset')
            )
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
    }

    function _getOverrideSystemTsv() {
      return preferencesService
        .getBooleanValue(PREFERENCE_PROPERTIES.TSV_ENABLED_OVERRIDE)
        .then(function (preferenceValue) {
          $scope.model.system_tsv.override = preferenceValue
        })
    }

    function _getEnabledSystemTsv() {
      return preferencesService
        .getBooleanValue(PREFERENCE_PROPERTIES.TSV_ENABLED)
        .then(function (preferenceValue) {
          $scope.model.system_tsv.enabled = preferenceValue
        })
    }

    function _getOrgTsv() {
      return tsvApiConfig.getOrganizationTsv().then(
        function (response) {
          var data = response.data
          $scope.model.org_tsv.enabled = data.tsv.enabled
          $scope.model.org_tsv.required = data.tsv.required
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _getUserTsv() {
      return tsvApiConfig.getUserTsv().then(
        function (response) {
          var data = response.data
          $scope.model.tsv.enabled = data.tsv.tsv_enabled
          $scope.model.tsv.type = data.tsv.tsv_type
          $scope.model.tsv.previousType = angular.copy(data.tsv.tsv_type)

          if (data.tsv.tsv_device) {
            $scope.model.tsv.device = TSV_DEVICE_ENUM[data.tsv.tsv_device]
          }

          $scope.model.google_configured = data.tsv.google_configured
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _checkUserTsvTypeConfiguration(tempType) {
      var promises = []
      promises.push(_updateUserTsvType(tempType))

      $q.all(promises).then(function () {
        _showScratchCodes()
        $scope.model.loading = false
      })
    }

    function _updateUserTsvType(tempType) {
      return tsvApiConfig.updateUserTsvType(tempType).then(function (response) {
        logger.logSuccess(
          $translate.instant('detail_twoStepVerification_changesSaved')
        )
        $scope.model.tsv.previousType = tempType
        $scope.model.tsv.type = tempType

        $scope.model.qr = response.data.qr
        $scope.model.token = response.data.key
        $scope.model.codes = response.data.scratch_codes
        $scope.model.tsv.device = undefined
        $scope.model.google_configured = false
      }, ErrorService.processError)
    }

    function _reset() {
      $scope.model.loading = true
      return tsvApiConfig.resetTsvCredentials().then(
        function (response) {
          $scope.model.qr = response.data.qr
          $scope.model.token = response.data.key
          $scope.model.codes = response.data.scratch_codes
          $scope.model.google_configured = false
          $scope.model.tsv.device = undefined
          $scope.model.loading = false
          logger.logSuccess(
            $translate.instant('detail_twoStepVerification_deviceReset')
          )

          _showScratchCodes()
        },
        function (response) {
          ErrorService.processError(response)
          $scope.model.loading = false
        }
      )
    }

    function _showScratchCodes() {
      return userTsvService.showScratchCodeModal($scope.model.codes)
    }

    init()
  }
})()
